import React, {Fragment} from "react";
import PropTypes from "prop-types";
import FuxEvents from "../../../../lib/FuxFramework/FuxEvents";
import {
    DLA_USER_MODULE_EVENT_GUEST_VIEW
} from "../../../../const/DeepLinkActionsCostants";
import {UserEventGuestPage} from "./UserEventGuestPage";
import ModalPortalHOC from "../../../../components/BaseComponents/ModalPortalHOC";

export class UserEventGuestListener extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userEventGuestPageOpen: false,
            eventLink: null
        }
    }

    componentDidMount() {
        FuxEvents.on(DLA_USER_MODULE_EVENT_GUEST_VIEW, this.handleUserEventPageOpen);
    }

    componentWillUnmount() {
        FuxEvents.off(DLA_USER_MODULE_EVENT_GUEST_VIEW, this.handleUserEventPageOpen);
    }

    handleUserEventPageOpen = event_link => {
        let decodedEventLink = event_link;
        try {
            decodedEventLink = decodeURIComponent(event_link);
        } catch (e) {
        }

        this.setState({eventLink: decodedEventLink, userEventGuestPageOpen: true});
    }

    handleUserEventPageClose = _ => this.setState({userEventGuestPageOpen: false, eventLink: null});

    render() {
        return (
            <Fragment>
                {
                    this.state.userEventGuestPageOpen &&
                    <ModalPortalHOC>
                        <UserEventGuestPage
                            onDismiss={this.handleUserEventPageClose}
                            eventLink={this.state.eventLink}
                        />
                    </ModalPortalHOC>
                }
            </Fragment>
        );
    }
}

UserEventGuestListener.propTypes = {
    onDismiss: PropTypes.func
}
